import { useCallback } from 'react'
import { useCreateValueBasedOverrideMutation, type ValueBasedOverrideRequestInput } from '.'

export const useCreateValueBasedOverride = () => {
  const [createValueBasedOverrideMutation, { data, called, loading, error }] =
    useCreateValueBasedOverrideMutation()

  const createValueBasedOverride = useCallback(
    (valueBasedOverrideInput: ValueBasedOverrideRequestInput) => {
      createValueBasedOverrideMutation({
        variables: {
          data: valueBasedOverrideInput,
        },
      })
    },
    [createValueBasedOverrideMutation]
  )

  return {
    createValueBasedOverride,
    apiSuccess: Boolean(data),
    apiLoading: loading,
    apiCalled: called,
    apiError: error,
  }
}
